module.exports = __webpack_public_path__ + "media/images/icons/icon-mp-63bfefc568620f546eb67f6c919b11b0.svg";